import React from 'react';
const OriginalIcon = (props) => {
    const attribute = Object.assign({}, props);
    const stroke = attribute.stroke || '#3F465C';
    delete attribute.stroke;
    return (React.createElement("svg", Object.assign({ width: "17", height: "16", viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, attribute),
        React.createElement("path", { d: "M8.86719 9.5H6.36719C4.71033 9.5 3.36719 10.8431 3.36719 12.5V13C3.36719 13.5523 3.8149 14 4.36719 14H8.86719", stroke: stroke, "stroke-linecap": "round" }),
        React.createElement("circle", { cx: "8.86719", cy: "5", r: "2.5", stroke: stroke }),
        React.createElement("path", { d: "M12.8672 9.69922L14.8672 11.6992M14.8672 11.6992L12.8672 13.6992M14.8672 11.6992H9.86719", stroke: stroke, "stroke-linecap": "round", "stroke-linejoin": "round" })));
};
export default OriginalIcon;
